var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"note",attrs:{"color":_vm.color,"elevation":"4"}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.content)+" ")]),_c('v-card-actions',[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.deleteNote}},[_c('v-icon',[_vm._v("mdi-delete")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }